import { Trade } from '../../types/entities';

export interface TradeHistoryStateByDate {
  loading: boolean;
  loaded: boolean;
  error?: string;
  trades: Trade[];
}

export const initialTradeHistoryStateByDate: TradeHistoryStateByDate = {
  loading: false,
  loaded: false,
  error: undefined,
  trades: []
};

export interface TradeHistoryState {
  [yearDashMonth: string]: TradeHistoryStateByDate;
}

export const initialTradeHistoryState: TradeHistoryState = {};
